import { ArrowUpRight } from "lucide-react";
import SectionReveal from "@/components/effects/SectionReveal";
import { VENTURES } from "@/data/content";
import { TID } from "@/constants/testIds";

const Ventures = () => {
    return (
        <section id="ventures" className="relative py-24 md:py-40">
            <div className="container-x">
                <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
                    <SectionReveal>
                        <p className="overline">02 — Current ventures</p>
                        <h2
                            className="mt-4 text-3xl font-medium tracking-tight text-white sm:text-4xl md:text-5xl"
                            style={{ fontFamily: "'General Sans', sans-serif" }}
                        >
                            Businesses I quietly run.
                        </h2>
                    </SectionReveal>
                    <SectionReveal delay={0.15}>
                        <p className="max-w-md text-sm text-brand-muted md:text-base">
                            Each one solves a different slice of the same problem: how modern brands and entrepreneurs
                            actually build online.
                        </p>
                    </SectionReveal>
                </div>

                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {VENTURES.map((v, i) => (
                        <SectionReveal key={v.id} delay={0.1 * i}>
                            <div
                                data-testid={TID.ventureCard(v.id)}
                                className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/[.08] bg-[#0b0b0b] p-8 card-lift"
                            >
                                <div
                                    aria-hidden
                                    className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                                />
                                <div className="flex items-center justify-between">
                                    <span className="chip">{v.tag}</span>
                                    <span className="text-xs text-brand-muted">{v.role}</span>
                                </div>
                                <h3
                                    className="mt-10 text-3xl font-medium tracking-tight text-white md:text-4xl"
                                    style={{ fontFamily: "'General Sans', sans-serif" }}
                                >
                                    {v.name}
                                </h3>
                                <p className="mt-4 flex-1 text-sm text-brand-muted md:text-base">{v.pitch}</p>
                                <div className="mt-8 flex flex-wrap gap-2">
                                    {v.highlights.map((h) => (
                                        <span key={h} className="chip">
                                            {h}
                                        </span>
                                    ))}
                                </div>
                                {v.url ? (
                                    <a
                                        data-testid={TID.ventureVisit(v.id)}
                                        href={v.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="mt-8 inline-flex w-fit items-center gap-2 text-sm font-medium text-white transition-colors hover:text-brand-primary"
                                    >
                                        Visit website
                                        <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                                    </a>
                                ) : (
                                    <span className="mt-8 inline-flex w-fit items-center gap-2 text-sm text-brand-muted">
                                        By referral only
                                    </span>
                                )}
                            </div>
                        </SectionReveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Ventures;
